<template>
  <PortalModal :open="open" @cancel="$emit('update:open', false)" @confirm="$refs.filter.confirm()">
    <FilterCard
      :initial-filter="initialFilter"
      :filter-options="filterOptions"
      :items="items"
      :entity-type="entityType"
      :title="title"
      @apply="$emit('apply', $event)"
      @cancel="$emit('update:open', false)"
      ref="filter"
      data-test-id="filter-form"
    >
      <template #saveButton="slotProps">
        <Btn @click="$emit('apply', slotProps.filter)" color="blue" data-test-id="button-main-action">
          {{ $t('action.apply') }}
        </Btn>
      </template>
    </FilterCard>
  </PortalModal>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { FilterList, FilterOptions } from '@/filter/types';
import FilterCard from '@/components/FilterCard.vue';
import PortalModal from '@components/PortalModal.vue';

export default defineComponent({
  name: 'FilterOverlay',

  components: {
    FilterCard,
    PortalModal,
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },

    initialFilter: {
      type: Object as PropType<FilterList>,
      required: true,
    },

    filterOptions: {
      type: Object as PropType<FilterOptions>,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    entityType: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      default: null,
    },
  },
  emits: { apply: null, 'update:open': null },
});
</script>
